import * as React from 'react';
import * as Glob from '../../Globale';
import * as Dati from '../../Dati';
import * as DatiRCP from '../../DatiRCP';
import {
    AccordionCampiPolizza,
    AccordionGaranzie,
    AccordionProdotti
} from '../';
import {BasePureComponent} from '../BaseComponent';

interface IComparatoreProfessioneSingolaState {

}

interface IIComparatoreProfessioneSingolaProps extends Dati.IBaseProps {
    ID_Polizza: number;
    Frazionamento: number;
    AbilitaModifica: boolean;
    DatiPolizza: Glob.DatiJSON | DatiRCP.CComparatoreSingolo;
    OnChangeGaranzia: (e: React.FormEvent<any> | string, valore?: any) => void;
    ID_TipoPolizzaStato: string;
    ID_GaranzieJSON: string;
    ID_PolizzeJSON: string;
    ID_DatoRCPPolizza: string;
    DimensioneMinima?: number;
    ProductsHeaderVisible?: boolean;
    ProductsBodyVisible?: boolean;
}

export class ComparatoreProfessioneSingola extends BasePureComponent<IIComparatoreProfessioneSingolaProps, IComparatoreProfessioneSingolaState> {

    private _DatiPolizza: DatiRCP.CComparatoreSingolo = new DatiRCP.CComparatoreSingolo();
    private _Polizze: DatiRCP.CRCPPolizze = new DatiRCP.CRCPPolizze();

    constructor(props: any) {
        super(props);
    }

    private PopolaDati() {
        if (this.props.DatiPolizza != undefined && this.props.DatiPolizza.toString() != "") {
            if (typeof (this.props.DatiPolizza) == "string") {
                this._DatiPolizza = JSON.parse(this.props.DatiPolizza);
            } else {
                this._DatiPolizza = this.props.DatiPolizza;
            }
        }

    }
    
    public render() {
        this.PopolaDati();
        //console.warn("GARANZIE CAPO", this.props.DatiPolizza);
        return <React.Fragment>
            <div className="card">
                <AccordionGaranzie Name={this.props.ID_GaranzieJSON} Id={this.props.ID_GaranzieJSON}
                    Value={this._DatiPolizza.GaranzieJSON}
                    OnChange={this.props.OnChangeGaranzia}
                    Abilitato={this.props.AbilitaModifica}
                    Indice={1} />

            </div>
            <div className="card">
                <AccordionProdotti Id={this.props.ID_PolizzeJSON} Name={this.props.ID_PolizzeJSON}
                    OnChange={this.props.OnChange}
                    Value={this._DatiPolizza.PolizzeJSON}
                    Abilitato={this.props.AbilitaModifica}
                    CampoPreventivoSelezionato="PreventivoSelezionato"
                    Indice={2}
                    Forzabili={(this.props.ID_TipoPolizzaStato == Glob.Tipi_PS_ConsolidataSottoscrittore)}
                    DimensioneMinima={this.props.DimensioneMinima}
                    ProductsHeaderVisible={this.props.ProductsHeaderVisible}
                    ProductsBodyVisible={this.props.ProductsBodyVisible} />
            </div>
            <div className="card">
                <AccordionCampiPolizza Gruppo="Livello3" Riga={3}
                    Info={this._DatiPolizza.CampiPolizza}
                    DatoPolizza={this._DatiPolizza.DatoRCPPolizza}
                    Identificatore={this.props.ID_DatoRCPPolizza}
                    Limiti={{}} OnChange={(e, v) => {
                        this.props.OnChange(e, v);
                        this.props.OnChangeGaranzia(e, undefined)
                    }} OnChangeDeroga={() => {
                    }} OnBlur={() => {
                    }} DimensioneGrafica={6} Abilitato={this.props.AbilitaModifica}
                    Indice={3} />
            </div>
        </React.Fragment>;
    }
}



// WEBPACK FOOTER //
// ./src/components/RCP/ComparatoreProfessioneSingola.tsx